import { getUserSettings, updateUserSettings } from "@/app/[locale]/actions/settings";

export interface StarkySenseSettings {
  isEnabled: boolean;
}

const STARKY_SENSE_SETTINGS_KEY = 'starkySense';
const DEFAULT_STARKY_SENSE_SETTINGS: StarkySenseSettings = { isEnabled: true }; // Default to on for users without saved preference

class StarkySenseService {
  private static instance: StarkySenseService;

  private constructor() { }

  static getInstance(): StarkySenseService {
    if (!StarkySenseService.instance) {
      StarkySenseService.instance = new StarkySenseService();
    }
    return StarkySenseService.instance;
  }

  async getSettings(): Promise<StarkySenseSettings> {
    try {
      const settings = await getUserSettings(STARKY_SENSE_SETTINGS_KEY);
      return { ...DEFAULT_STARKY_SENSE_SETTINGS, ...settings };
    } catch (error) {
      console.error('Failed to get Starky Sense settings:', error);
      return DEFAULT_STARKY_SENSE_SETTINGS;
    }
  }

  async updateSettings(settings: Partial<StarkySenseSettings>): Promise<void> {
    try {
      await updateUserSettings(STARKY_SENSE_SETTINGS_KEY, settings);
    } catch (error) {
      console.error('Failed to update Starky Sense settings:', error);
    }
  }
}

export const starkySenseService = StarkySenseService.getInstance();
